module.exports = __webpack_public_path__ + "img/boiler-N-fire.93602174.png";